import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";
import { useSelector } from "react-redux";
import { withRouter, Link, useHistory, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import profile from "../../assets/images/profile-img.png";
import logo from "assets/images/short-logo.png";
import { resetPassword } from "services/userServices";
import useApiStatus from "common/useApiStatus";
import Hide from "../../assets/images/hide.png";
import Show from "../../assets/images/view.png";
import Loader from "common/loader";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ResetPasswordPage = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const { apiStatus, changeApiStatus } = useApiStatus();

  const history = useHistory();
  let query = useQuery();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(4, props.t("Too Short"))
        .max(20, props.t("Too Long"))
        .required(props.t("This Field is Required")),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], props.t("Passwords Must Match"))
        .required(props.t("This Field is Required")),
    }),
    onSubmit: async (values) => {
      try {
        changeApiStatus(true, "");
        var token = query.get("resetId");
        const response = await resetPassword(values.password, token);
        if (response.status === 200) {
          changeApiStatus(false, "");

          history.push("/login");
        } else {
          changeApiStatus(false, "");
          throw new Error(response.error);
        }
      } catch (err) {
        // showToast("error", props.t(`${errorHandle(err)}`));
        changeApiStatus(false, "");
      }
    },
  });

  const { forgetError, forgetSuccessMsg } = useSelector((state) => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }));

  useEffect(() => {
    setTimeout(() => {
      changeApiStatus(false, "");
    }, 1500);
  }, []);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };

  return apiStatus.inProgress ? (
    <Loader />
  ) : (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-dark bg-soft bg-soft-dark">
                  <Row>
                    <Col xs={7}>
                      {/* <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Benefito.</p>
                      </div> */}
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <div className="position-relative">
                          <Label className="form-label">
                            {props.t("Password")}
                          </Label>
                          <Input
                            name="password"
                            className="form-control"
                            placeholder={props.t("Enter New Password")}
                            type={showPassword ? " text" : "password"}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <img
                            onClick={toggleShowPassword}
                            className=" view view_password"
                            src={showPassword ? Show : Hide}
                            alt="hide"
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="position-relative">
                          <Label className="form-label">
                            {props.t("Confirm Password")}
                          </Label>
                          <Input
                            name="confirmPassword"
                            className="form-control"
                            placeholder={props.t("Enter Confirm Password")}
                            type={showPassword1 ? " text" : "password"}
                            onPaste={(e) => e.preventDefault()}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirmPassword || ""}
                            invalid={
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword
                                ? true
                                : false
                            }
                          />
                          <img
                            onClick={toggleShowPassword1}
                            className=" view view_password"
                            src={showPassword1 ? Show : Hide}
                            alt="hide"
                          />
                          {validation.touched.confirmPassword &&
                          validation.errors.confirmPassword ? (
                            <FormFeedback type="invalid">
                              {validation.errors.confirmPassword}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button className="btn btn-dark w-md " type="submit">
                            {props.t("Reset")}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-3 text-center">
                <p className="fw-bold">
                  {props.t("Go Back")}{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    {props.t("Login")}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Hommies.{" "}
                  {props.t("Crafted With")}{" "}
                  <i className="mdi mdi-heart text-danger" /> {props.t("By")}{" "}
                  Blocktech Brew
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ResetPasswordPage.propTypes = {
  t: PropTypes.any,
};
export default withRouter(withTranslation()(ResetPasswordPage));
